export default "__VITE_ASSET__3jsVa8PA__"